import { Box } from '@mui/material';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import Params from '../../../Types/ParamsPicklist';

let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchVille: Params = { CodeAgence: '', Table: "CdVille", Colonne1: "CdVille", Colonne2: "Libell", Colagence: '001', Choix: 22 }

const Tab4 = (props: { form?: any }) => {
  return (
    <div className='tabItem'>
      <div >
        <Box display={'flex'} fontStyle="inherit" width={"85%"} position={"absolute"} >
          <Box fontStyle="inherit" className='border-left border'>

            <legend>Adresse Client</legend>
            <SearInputM notRequired  disabled width={7}  Titre='Recherche Type Adresse' label='Type Adresse' name="TYPADR" Parametre={searchTypAdr} form={props.form} />
            <SearInputM notRequired  disabled width={7}  Titre='Recherche Ville' label='Ville' name="vilCli" Parametre={searchVille} form={props.form} />

            <Box fontStyle="inherit" display={"flex"}>
              <Box className='border-left' >

                <InputForm width={10} disabled notRequired label='Boite Postale' name='adrPostal' type='text' error=' ce Champ est obligatiore' />
                <InputForm notRequired disabled  width={10} label='Numéro' name='Tel2' type='number' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Téléphone Mobile' name='telCli' type='number' error=' ce Champ est obligatiore'    />
                <InputForm width={10} disabled notRequired label='Faxcli' name='FaxCli' type='text' error=' ce Champ est obligatiore' />

              </Box>
              <Box className='border-left' >

                <InputForm width={10} disabled notRequired label='Nom du quatier' name='nomQtier' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Numéro Rue' name='rueCli' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Adresse Email' name='EmailCli' type='email' error=' ce Champ est obligatiore' />
                <InputForm notRequired disabled width={10} label='Adresse Domicile' name='NumDomCli' type='text' error=' ce Champ est obligatiore' />

              </Box>
            </Box>
          </Box>

          <Box fontStyle="inherit" className='border-left border'>

            <legend>Information Employeur/Famille</legend>
            <Box fontStyle="inherit" display={"flex"}>
              <Box className='border-left' >
                <InputForm width={10} disabled notRequired label='Nombre Enfant' name='nbrEnfant' type='number' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Nombre Personne à charge' name='nbrPersCharge' type='number' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Nom Employeur' name='NOMEMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Matricule Employeur' name='MATEMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='No Contribuable' name='NOCONT' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Nom du père' name='nompere' type='text' error=' ce Champ est obligatiore' />
              </Box>

              <Box className='border-left' >
                <InputForm width={10} disabled notRequired label='Revenu mensuel' name='revenuCli' type='number' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Adresse Employeur' name='ADREMP' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Numéro CNPS' name='NOCNPS' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Adresse Internet' name='numCnet' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Profession' name='profesion' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={10} disabled notRequired label='Nom de la mère' name='nommere' type='text' error=' ce Champ est obligatiore' />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box display={"flex"} fontStyle="inherit" className='border-left bordure1 tabElement2'>
          <InputForm notRequired disabled taille={200} width={10} label='UTILISATEUR  CREER' name='UTILIS' defaultValue='' type='text' error='mobile' />
          <InputForm notRequired disabled taille={200} width={10} label='UTILISATEUR  VALIDER' name='UTILVAL' defaultValue='' type='text' error='mobile' />
          <InputForm notRequired disabled taille={200} width={10} label='DATE CREATION' name='DATCRE' defaultValue='' type='text' error='mobile' />
        </Box>
      </div>
    </div>

  );

}

export default Tab4;